import { get, post } from '@/apis/http';
import { apiPath } from '@/config';
import { getIpConfig } from '@/utils/IMEI';
import request from '@/utils/axios';

// 获取验证码（网易易盾行为验证码二次校验，data.validate）
export function postVerifiCode (data, header) {
  return post(apiPath + '/common/yiDunCheckCode', data, header)
}

// 注册接口
export function postRegister (data, header) {
  return post(apiPath + '/uc/registerAccount/register', data, header)
}

// 获取个人信息
export function queryUserInfo () {
  return get(apiPath + '/uc/user/userinfo/identityInfo')
}

// 登录
// export function postLogin (data, header) {
//   return post(apiPath + '/uc/appLogin', data, header)
// }

export async function postLogin(data, header) {
  const ip = await getIpConfig();
  data = { ...ip, ...data };
  return request({
    url: apiPath + '/uc/appLogin',
    method: 'POST',
    data,
    header
  })
}

// 基础认证
export function postBaseCheck (data, header) {
  return post(apiPath + '/uc/user/userinfo/baseCheck', data, header)
}
// 钱包'/uc/walletInfo'
export function queryWalletInfo() {
  return get(apiPath + '/uc/walletInfo')
}
// 钱包提取明细uc/walletGrants
export function queryWalletGrants(data, header) {
  return post(apiPath + '/uc/walletGrants', data, header)
}

// 个人赠金点明细列表
export function queryPointList(data) {
  return post(apiPath + '/uc/userGrantsPoint/grantsPointDetail', data)
}